module.exports = "mutation CreateBlogPost($input: JSON!) {\n  createBlogPost(input: $input) {\n    id\n  }\n}"